import { render, staticRenderFns } from "./information.vue?vue&type=template&id=c95e6260&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=c95e6260&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95e6260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c95e6260')) {
      api.createRecord('c95e6260', component.options)
    } else {
      api.reload('c95e6260', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=c95e6260&scoped=true", function () {
      api.rerender('c95e6260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesman/staffManage/staffForm/information.vue"
export default component.exports